<app-modal #modal class="create-mileage-rate-modal">
  <div class="modal-header">
    <h2 class="modal-title">Add Engine Size Rate</h2>
  </div>

  <div class="modal-body">
    <form [formGroup]="ruleForm">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="engineSize">Engine Size</label>
          <input type="text" class="form-control w-100" id="engineSize" formControlName="engineSize" name="engineSize">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="currency">Distance Unit</label>
          <app-dropdown-input #distanceUnitSelect id="distanceUnit" [options]="distanceUnits" [parentForm]="ruleForm" name="distanceUnit"
            placeholder="Select distance unit">
          </app-dropdown-input>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="currency">Currency</label>
          <app-dropdown-input #currencySelect id="currency" [options]="currencies" [parentForm]="ruleForm"
            name="currency" placeholder="Select currency">
          </app-dropdown-input>
        </div>
      </div>

      <ng-container *ngFor="let form of distanceLimitForms; let i = index;">
        <form [formGroup]="form">
          <div class="row">
            <div class="form-group col-md-3">
              <label for="distanceFrom">From (distance)</label>
              <input class="form-control w-100" type="number" id="distanceFrom" formControlName="distanceFrom"
                name="distanceFrom">
              <span class="error-text"
                *ngIf="form.getError('rangeError') || form.get('distanceFrom').getError('rangeError')">Value has to
                be greater than previous To distance and less than this To distance </span>
            </div>
            <div class="form-group col-md-3">
              <label for="distanceTo">To (distance)</label>
              <input class="form-control w-100" type="number" id="distanceTo" formControlName="distanceTo"
                name="distanceTo">
              <span class="error-text"
                *ngIf="form.getError('rangeError') || form.get('distanceTo').getError('rangeError')">Value has to
                be greater than this From distance and less than next To distance </span>
            </div>
            <div class="form-group col-md-3">
              <label for="amountPerDistance">Amount per d</label>
              <input class="form-control w-100" type="number" id="amountPerDistance" formControlName="amountPerDistance"
                name="amountPerDistance">
            </div>
            <div class="form-group col-md-3 trash-column">
              <div>
                <label for="extraAmount">Extra amount</label>
                <input [style.width]="i !== 0 ? '95%' : '100%'" class="form-control" type="number" id="extraAmount"
                  formControlName="extraAmount" name="extraAmount">
              </div>
              <mat-icon (click)="removeLimit(i)" class="delete-icon" *ngIf="i !== 0">delete</mat-icon>
            </div>
          </div>
        </form>
      </ng-container>

      <div class="row">
        <div class="col-md-12">
          <div style="display: flex; flex-direction: row; justify-content: flex-end">
            <app-button text="+" size="sm" [disabled]="!nextLimitAvailable()" (clicked)="addDistanceLimit()" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="note">Shorthand notation</label>
          <textarea disabled class="form-control" style="width: 100% !important;">{{shorthandNotation}}</textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="note">Notes / Description</label>
          <textarea class="form-control" style="width: 100% !important;" id="note" formControlName="note"
            name="note"></textarea>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="model-footer__buttons">
      <app-button text="Cancel" variant="secondary" (clicked)="hideModal()" />
      <app-button text="Save" type="submit" [isBusy]="isFormProcessing" [disabled]="!formsValid() || isFormProcessing" (clicked)="submit()" />
    </div>
  </div>
</app-modal>
